<template>
    <div class='h-dialogContainer h-nomargin '>
        <div class='row'>
            <div class='h-col-inputBox col-sm-12 nopadding'>
                <div class='col-sm-8 row nopadding'>
                    <div class='h-inputLit'>{{$t('Software.td_executionTime')}}</div>
                    <ejs-datetimepicker :locale='locale' :format="format" :timeFormat='timeFormat' v-model='timevalue'></ejs-datetimepicker>
                </div>
            </div>
            <div class='col-sm-12 nopadding'>
                <div class='col-sm-7'>
                    <div>{{$t('Software.backcaution')}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {stringify} from 'qs';
export default {
    name: 'active-task',
    data() {
        return{
            format: 'yyyy-MM-dd HH:mm:ss',
            timeFormat: 'HH:mm:ss',
            locale: localStorage.getItem('locale'),
            timevalue: new Date(),
        }
    },
    methods: {
        active(taskObjs,callback) {
            let config = {
                headers: {
                    "Content-Type": "application/json"
                }
            };
            let params = {
                execTime: new Date(this.timevalue).Format("yyyy-MM-dd HH:mm:ss"),
                systemId: "1",
                isUpLoad: 1
            };
            this.axios.post(`/lte/ems/verupdate_new/activeAction?${stringify(params)}`, JSON.stringify(taskObjs), config).then(response => {
                console.log('activeAction', response);
                callback();
            });
        }
    }
};
</script>>